/**
 * The default  application constants should be defined here
 * @type {string}
 */
export const LoginApiUrl: string = process.env.NEOTRACK_API_URL + "/api/login";
export const SaveUserDetailsApiUrl: string = "users/save";
